/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetNetworkIngressSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetNetworkIngressRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetNetworkIngressSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetNetworkIngressSecurity$outboundSchema: z.ZodMiniType<
  GetNetworkIngressSecurity$Outbound,
  GetNetworkIngressSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getNetworkIngressSecurityToJSON(
  getNetworkIngressSecurity: GetNetworkIngressSecurity,
): string {
  return JSON.stringify(
    GetNetworkIngressSecurity$outboundSchema.parse(getNetworkIngressSecurity),
  );
}

/** @internal */
export type GetNetworkIngressRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetNetworkIngressRequest$outboundSchema: z.ZodMiniType<
  GetNetworkIngressRequest$Outbound,
  GetNetworkIngressRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getNetworkIngressRequestToJSON(
  getNetworkIngressRequest: GetNetworkIngressRequest,
): string {
  return JSON.stringify(
    GetNetworkIngressRequest$outboundSchema.parse(getNetworkIngressRequest),
  );
}
